import { forwardRef } from 'react';
import * as views from './List.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var List = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return _jsx(views.List, {
    ref: ref,
    role: "menu",
    children: children
  });
});
export default List;